module.exports = __webpack_public_path__ + "img/person-walking-with-cane.1c9cdc33.svg";